import {
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { environment as appEnv } from "../../environments/environment";
import { EventService } from "../event-service/event.service";

@Component({
  selector: "ab-project-language-icon",
  templateUrl: "./project-language-icon.component.html",
})
export class ProjectLanguageIconComponent implements OnInit, OnDestroy {
  @HostBinding("class") classAttribute = "d-flex align-items-center mr-2";
  @Input() public project: any;

  public language: string;
  public appEnv = appEnv;

  private languageChangedSub: any;

  constructor(private eventService: EventService) {}

  public ngOnInit() {
    this.language = this.setLanguage(this.project.language);

    this.languageChangedSub = this.eventService.subscribe(
      "language:changed",
      (data: { projectId: number; language: string }) => {
        if (this.project.id === data.projectId) {
          this.language = this.setLanguage(data.language);
        }
      },
    );
  }

  public ngOnDestroy() {
    this.languageChangedSub.unsubscribe();
  }

  private setLanguage(language: string) {
    return language !== "other" ? language : undefined;
  }
}
